var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.invoice)?_c('div',{staticClass:"page page--invoice-view"},[_c('h1',{staticClass:"mb-5"},[_vm._v(_vm._s(_vm.invoice.title))])]):_c('vp-loader')
}
var staticRenderFns = []

export { render, staticRenderFns }